__webpack_require__.p = "https://assets.scaler.com/frontend-apps/scm/";